<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="staffInfoAudits && staffInfoAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list (nextPage)="onNextPage()" [audits]="staffInfoAudits">
    </sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Staff Detail audits </ng-template>
</ng-template>
